import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../../store/index';
import SliderOnly from '../slider';
import { Input, Button, message } from 'antd'
import { apiGetCaptchaWord, apiAccountLogin, apiPostEmailCaptcha, apiLoginByEmailCaptcha } from '../../request/api'
import { useCustomData } from '../../pages/context/loginCustomDataProvider';

interface EmailVerificationProps {
    handleViewChange: (newView: string, data?: any) => void;
    data?: any;
}

interface loginInfo {
    loginName?: string;
    email?: string;
    phone?: string;
    password?: string;
    verification?: string;
    account?: string;
    emailError?: string;
    phoneError?: string;
    accountError?: string;
    passwordError?: string;
    verificationError?: string;
    enterAccount?: string;
    enterEmail?: string;
    enterPassword?: string;
    enterPasswordAgain?: string;
    enterVerification?: string;
    enterPhone?: string;
    forget?: string;
    getBack?: string;
    next?: string;
    check1?: string;
    verifyIdentity?: string;
    resetPassword?: string;
    orInfo?: string;
    backLogin?: string;
    seccond?: string;
    changeInfo?: string;
    sendVerification?: string;
    verifyIdentityFor?: string;
    sendIdentifying?: string;
}

const EmailVerification: React.FC<EmailVerificationProps> = ({ handleViewChange, data }) => {
    const themeColor = useSelector((state: RootState) => state.themeColor.value);
    const navigate = useNavigate();
    const [identifying, setIdentifying] = useState('')
    const [identifyingString, setIdentifyingString] = useState<string | null | undefined>('发送验证码');
    const [countdown, setCountdown] = useState(0);
    const [isHovered, setIsHovered] = useState(false);
    const [captcha, setCaptcha] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState<string | null>('');
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);
    const [isButtonLoading, setIsButtonLoading] = useState(false);
    const [sliderOnly, setSliderOnly] = useState(0)
    const [ok, setOk] = useState(0);
    const [messageApi, contextHolder] = message.useMessage();
    const [loginInfo, setLoginInfo] = useState<loginInfo>({
        loginName: "", email: "", phone: "", password: "", verification: "", account: "", emailError: "", sendVerification: "",
        phoneError: "", accountError: "", passwordError: "", verificationError: "", enterAccount: "", enterEmail: "",
        enterPassword: "", enterPasswordAgain: "", enterVerification: "", enterPhone: "", forget: "", verifyIdentityFor: "",
        getBack: "", next: "", check1: "", verifyIdentity: "", resetPassword: "", orInfo: "", backLogin: "", seccond: "", changeInfo: "",
        sendIdentifying: ''
    });
    const { getValue, customData } = useCustomData();

    useEffect(() => {
        if (customData.length === 0) return; // 数据还没来
        const newLoginInfo: loginInfo = {
            loginName: getValue('loginName'),
            email: getValue('email'),
            phone: getValue('phone'),
            password: getValue('password'),
            verification: getValue('verification'),
            account: getValue('account'),
            emailError: getValue('emailError'),
            phoneError: getValue('phoneError'),
            accountError: getValue('accountError'),
            passwordError: getValue('passwordError'),
            verificationError: getValue('verificationError'),
            enterAccount: getValue('enterAccount'),
            enterEmail: getValue('enterEmail'),
            enterPassword: getValue('enterPassword'),
            enterPasswordAgain: getValue('enterPasswordAgain'),
            enterVerification: getValue('enterVerification'),
            enterPhone: getValue('enterPhone'),
            forget: getValue('forget'),
            getBack: getValue('getBack'),
            next: getValue('next'),
            check1: getValue('check1'),
            verifyIdentity: getValue('verifyIdentity'),
            resetPassword: getValue('resetPassword'),
            orInfo: getValue('orInfo'),
            backLogin: getValue('backLogin'),
            seccond: getValue('seccond'),
            changeInfo: getValue('changeInfo'),
        };
        setIdentifyingString(getValue('sendIdentifying'))
        setLoginInfo(newLoginInfo);
    }, [customData]);


    // 输入框的值变化
    const handleCaptchaChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setCaptcha(e.target.value);
    };

    const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPassword(e.target.value);
    };

    const goLogin = () => {
        // 点击按钮时校验输入内容
        if (ok === 0) {
            if (captcha.length < 6) {
                setError(loginInfo.verificationError || '验证码长度不足6位');
                return;
            }
            apiLoginByEmailCaptcha({
                email: data.email,
                emailCaptcha: captcha
            }, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(res => {
                messageApi.open({
                    type: 'success',
                    content: res.data.msg,
                });
                const token = res.data.data.token;
                localStorage.setItem('userToken', token);
                navigate('/mine')
            }).catch(req => {
                console.error(req);
                messageApi.open({
                    type: 'error',
                    content: '登录失败',
                })
            })
        } else {
            if (password.length < 6) {
                setError(loginInfo.passwordError || '密码长度不足6位');
                return;
            }
            apiAccountLogin({
                accountName: data.email,
                password: password,
            }, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(res => {
                const token = res.data.data.token;
                localStorage.setItem('userToken', token);
                sessionStorage.setItem('userToken', token)
                navigate('/mine')
            }).catch(err => {
                console.error('登录失败:', err);
                messageApi.open({
                    type: 'error',
                    content: '登录失败',
                })
            });
        }
        // 如果校验通过，清除错误提示
        setError(null);
    };

    const handleGetCode = () => {
        console.log(data.email)
        if (sliderOnly == 0) {
            messageApi.open({
                type: 'error',
                content: '请进行验证',
            });
        } else {
            apiGetCaptchaWord({
                key: data.email
            }).then(res => {
                console.log('11111')
                setIsButtonLoading(true)
                setTimeout(() => {
                    apiPostEmailCaptcha({
                        captcha: res.data.data,
                        email: data.email
                    }, {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded'
                        }
                    }).then(emailres => {
                        messageApi.open({
                            type: 'success',
                            content: emailres.data.data,
                        });
                        console.log(emailres)
                        setIsButtonDisabled(true);
                        setCountdown(60);
                        setIsButtonLoading(false)
                    })
                }, 3000);
            }).catch(err => {
                console.log(err)
            });
        }

    }

    const switchTab = [
        {
            'switchname': loginInfo.verification
        },
        {
            'switchname': loginInfo.password
        },
    ]

    useEffect(() => {
        if (countdown > 0) {
            const timer = setTimeout(() => {
                setCountdown(countdown - 1);
            }, 1000);

            // 清除定时器，防止内存泄漏
            return () => clearTimeout(timer);
        } else if (countdown === 0) {
            // 倒计时结束，启用按钮
            setIsButtonDisabled(false);
        }
    }, [countdown]);

    const Verification = () => {
        handleViewChange('resetPassword', data.acount)
    }

    const onSuccess = () => {
        setSliderOnly(1)
    };

    const onError = () => {
        alert('滑动验证失败，请重试。');
    };
    const toAcountVerification = () => {
        handleViewChange('loadAccount', data.email)
    }

    const backToLoginPage = () => {
        handleViewChange('mainLogin', data.acount)
    }


    return (
        <div>
            {contextHolder}
            <div className='login-header'>{loginInfo.loginName}</div>
            <div className='login-body'>
                <span>{data.email}</span>
                <span onClick={backToLoginPage} className='cursur' style={{ color: themeColor, cursor: 'pointer' }}>{loginInfo.changeInfo}</span>
            </div>
            <div className='login-text' style={{ marginTop: '24px' }}>
                {switchTab.map((item, index) => (
                    <span key={index} className='login-switch'
                        onClick={() => {
                            setOk(index);
                            setError('');
                            setCaptcha('');
                            setPassword('');
                            setSliderOnly(0);
                        }}
                        style={{
                            color: index === ok ? themeColor : 'inherit',
                            cursor: 'pointer'
                        }}>{item.switchname}</span>
                ))}
            </div>
            {ok == 0 &&
                <div className="slider-wrapper" style={{ marginBottom: '30px' }}>
                    <SliderOnly
                        width={360}
                        fragmentSize={40}
                        onSuccess={onSuccess}
                        onError={onError}
                        color={themeColor}
                        tdrage={getValue('tdrage')}
                        inforScuess={getValue('inforScuess')}
                    />
                </div>
            }
            {ok == 0 &&
                <div className='login-body-native'>
                    <Input status={error ? 'error' : ''}
                        placeholder={loginInfo.enterVerification} value={captcha} onChange={handleCaptchaChange} />
                    <Button disabled={isButtonDisabled} onClick={handleGetCode} loading={isButtonLoading}
                        style={{
                            color: isButtonDisabled ? '#e5e5ee' : 'inherit'
                        }}
                    >
                        {countdown > 0 ? `${countdown}` + `${loginInfo.seccond}` : identifyingString}
                    </Button>
                </div>
            }
            {ok == 1 &&
                <Input.Password status={error ? 'error' : ''}
                    placeholder={loginInfo.enterPassword} value={password} onChange={handlePasswordChange} />
            }
            {error && (
                <div style={{ color: '#e60d0d', marginTop: '2px', fontSize: '12px' }}>
                    {error}
                </div>
            )}

            <Button type="primary" onClick={goLogin}>{loginInfo.loginName}</Button>
            {ok == 1 &&
                <div className='login-bottom'
                    style={{
                        color: isHovered ? themeColor : "inherit"
                    }}
                    onClick={toAcountVerification}
                    onMouseEnter={() => { setIsHovered(true) }}
                    onMouseLeave={() => { setIsHovered(false) }}
                >{loginInfo.forget}?</div>
            }
        </div>
    )

};

export default EmailVerification;